import multiplier from './multiplier';
import tradeable from './tradeable';

export default {
  multiplier,
  tradeable,
};
